/**
 * Generic Cache Manager for Services
 * Handles cache storage, timestamp tracking, and expiration
 */
export class CacheManager {
  constructor(timeout = 5 * 60 * 1000) { // Default 5 minutes
    this.cache = null;
    this.cacheTimestamp = null;
    this.cacheTimeout = timeout;
  }

  /**
   * Check if cache is valid
   * @returns {boolean}
   */
  isValid() {
    return this.cache !== null && 
           this.cacheTimestamp !== null &&
           (Date.now() - this.cacheTimestamp) < this.cacheTimeout;
  }

  /**
   * Get cached data if valid
   * @returns {any|null}
   */
  get() {
    return this.isValid() ? this.cache : null;
  }

  /**
   * Set cache with current timestamp
   * @param {any} data - Data to cache
   */
  set(data) {
    this.cache = data;
    this.cacheTimestamp = Date.now();
  }

  /**
   * Clear cache
   */
  clear() {
    this.cache = null;
    this.cacheTimestamp = null;
  }
}

